import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getKeuanganContent = createAsyncThunk('/keuangan/content', async () => {
    const userId = localStorage.getItem("userId")
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listCompanyFinancialFile/${userId}`, {})
    return response.data;
})

export const keuanganSlice = createSlice({
    name: 'keuangan',
    initialState: {
        isLoading: false,
        keuangan : []
    },
    reducers: {


        addNewKeuangan: (state, action) => {
            let {newKeuanganObj} = action.payload
            state.keuangan = [...state.keuangan, newKeuanganObj]
        },

        deleteKeuangan: (state, action) => {
            let {index} = action.payload
            state.keuangan.splice(index, 1)
        }
    },

    /*extraReducers: {
        [getKeuanganContent.pending]: state => {
			state.isLoading = true
		},
        [getKeuanganContent.fulfilled]: (state, action) => {
            state.keuangan = action.payload.data
			state.isLoading = false
		},
        [getKeuanganContent.rejected]: state => {
			state.isLoading = false
		},
    }*/
   extraReducers: (builder) => {
        builder
          .addCase(getKeuanganContent.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(getKeuanganContent.fulfilled, (state, action) => {
            state.keuangan = action.payload.data;
            state.isLoading = false;
          })
          .addCase(getKeuanganContent.rejected, (state) => {
            state.isLoading = false;
          });
      }
})

export const { addNewKeuangan, deleteKeuangan } = keuanganSlice.actions

export default keuanganSlice.reducer